import * as GLOBALS from "../globals";
import Rellax from "rellax";

export default class ParallaxAnimation {
	static init() {
		if (window.innerWidth < GLOBALS.BREAKPOINT_LG) return;

		return new ParallaxAnimation();
	}

	constructor() {
		var rellax = new Rellax('[data-rellax]');

		window.addEventListener('resize', this.debounce(function () {
			if (typeof rellax.destroy === 'function') {
				rellax.destroy();
				ParallaxAnimation.init();
			}
		}));
	}

	debounce(func) {
		var timer;
		return function (event) {
			if (timer) clearTimeout(timer);
			timer = setTimeout(func, 100, event);
		};
	}
}
